<template>
  <div>
    <section class="hero is-link is-fullheight">
      <div class="hero-head">
        <nav class="navbar">
          <div class="container">
            <div class="navbar-end">
              <div class="tabs is-right">
                <span v-if="!isAuthenticated" class="navbar-item">
                  <router-link
                    :to="{ name: 'login' }"
                    class="button is-white is-outlined"
                    data-tooltip="Tooltip Text"
                  >
                    <i class="material-icons">person</i>&nbsp; Mi cuenta
                  </router-link>
                </span>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column">
              <div class>
                <span>
                  <img
                    :class="selectclass('logo')"
                    src="@/assets/logoyungol.svg"
                    alt="Logo"
                  />
                </span>
              </div>
              <div :class="selectclass('largoflecha')">
                <div :class="selectclass('flecha')">
                  <img
                    src="@/assets/flecha.gif"
                    :class="selectclass('sizeflecha')"
                  />
                </div>
              </div>
              <div>
                <span :class="selectclass('manosexpertas')">
                  En
                  <br />manos <br />expertas.
                </span>
              </div>
            </div>
            <div class="column">
              <div class="box" :class="selectclass('boxcontactenos')">
                <h1 class="title has-text-link has-text-centered is-3">
                  La nueva forma
                  <br />de llevar la contabilidad
                </h1>
                <h2 class="subtitle has-text-link has-text-centered">
                  Contador especializado, facturación electrónica, información
                  de tu empresa en tiempo real y más.
                </h2>
                <div class="field">
                  <p class="control has-icons-left">
                    <input
                      v-model="contacto.name"
                      class="input is-large has-background-light"
                      type="text"
                      placeholder="Nombre"
                    />
                    <span class="icon is-small is-left">
                      <span class="material-icons"
                        >sentiment_satisfied_alt</span
                      >
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control has-icons-left">
                    <input
                      class="input is-large has-background-light"
                      type="text"
                      v-model="contacto.empresa"
                      placeholder="Empresa"
                    />
                    <span class="icon is-small is-left">
                      <span class="material-icons">location_city</span>
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control has-icons-left">
                    <input
                      class="input is-large has-background-light"
                      type="email"
                      v-model="contacto.email"
                      placeholder="Correo"
                    />
                    <span class="icon is-small is-left">
                      <span class="material-icons">email</span>
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control has-icons-left">
                    <input
                      class="input is-large has-background-light"
                      type="text"
                      v-model="contacto.telefono"
                      placeholder="Teléfono"
                    />
                    <span class="icon is-small is-left">
                      <span class="material-icons">phone</span>
                    </span>
                  </p>
                </div>
                <div class="field is-grouped is-grouped-centered">
                  <p class="control">
                    <a class="button is-link is-large" @click="sendcontacto"
                      >Quiero saber más</a
                    >
                  </p>
                </div>
              </div>
              <div style="float: left" v-if="!isMovil">
                <div class="contador">
                  <img src="@/assets/cont1.svg" alt="contador" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-4 is-offset-1">
              <h1 class="title is-1">
                ¿Eres <br />
                Empresario?
              </h1>
              <br />
              <p class="description is-size-4">
                Es hora de un cambio, deja que un contador especializado se
                encargue de todos tus temas contables
              </p>
              <br />
              <br />
              <a
                class="button is-block is-primary is-fullwidth is-medium"
                href="https://api.whatsapp.com/send?phone=573195379810&text=Hola!%20Quiero%20conocer%20mas%20sobre%20yungol."
                target="blank"
                >Quiero Saber más</a
              >
            </div>
            <div class="column is-4 is-offset-1">
              <img src="@/assets/empresario.svg" alt="empresario" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-fullheight is-primary is-bold">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-5 is-offset-1">
              <img src="@/assets/contadorsolo.svg" alt="" />
            </div>
            <div class="column is-4 is-offset-1">
              <h1 class="title is-1">
                ¿Eres <br />
                Contador
              </h1>
              <p class="description">
                Sé parte del equipo yungol y lleva tus contabilidades de manera
                ágil, ordenada y desde un solo lugar. Un software que se adapta
                a tus necesidades. Fácil, rápido y que funciona como un software
                de escritorio.
              </p>
              <br />
              <form>
                <div class="field">
                  <div class="control">
                    <input
                      class="input is-medium"
                      type="text"
                      placeholder="Nombre"
                      v-model="contacto.name"
                    />
                  </div>
                </div>

                <div class="field">
                  <div class="control">
                    <input
                      class="input is-medium"
                      type="email"
                      v-model="contacto.email"
                      placeholder="Correo"
                    />
                  </div>
                </div>
                <button
                  class="button is-block is-link is-fullwidth is-medium"
                  @click="sendcontacto('contador')"
                >
                  Enviar
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-fullheight is-link" id="fraelect">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-7">
              <img src="@/assets/facturaelectronica.svg" alt="" />
            </div>
            <div class="column is-5">
              <strong>
                <h1 class="title is-1">Facturación Electrónica</h1>
                <h2 class="subtitle">Desde $100.000 mensuales.</h2>
              </strong>

              <br />
              <p>
                Factura Electrónicamente al instante, sin costos adicionales de
                implementación, en el momento en que activamos tu empresa
                iniciamos con las pruebas para tu facturación, en maximo dos
                días realizaras tu primera factura aprobada por la DIAN.
              </p>
              <p>
                <br />
                No sólo tendras factura electrónica, tambien incluye todos los
                módulos de nuestro software contable.
              </p>
              <br />
              <a
                class="button is-block is-primary is-fullwidth is-medium"
                href="https://api.whatsapp.com/send?phone=573195379810&text=Hola!%20Quiero%20conocer%20mas%20sobre%20yungol%20y%20la%20factura%20electrónica."
                target="blank"
              >
                Quiero hablar con un asesor
              </a>
              <br />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <p class="has-text-centered">
                <small>
                  Conoce la norma y porque debes Facturar Electronicamente.
                  Resolución 000042 de 05 de Mayo de 2020.
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-4">
              <img src="@/assets/empresariayungol.svg" alt="" />
            </div>
            <div class="column">
              <div class="box">
                <div class="is-size-2 has-text-centered">
                  <strong>
                    <h1>yungol plus</h1>
                  </strong>
                </div>
                <div class="has-text-centered">
                  <H2>Desde $500.000 mensual</H2>
                </div>

                <br />

                <div class="column has-text-primary has-text-centered">
                  <p>
                    Contador Virtual <br />
                    Software contable <br />
                    Facturación Electrónica <br />
                    Modulo de Informes <br />
                    Módulo Facturación <br />
                    Módulo Pagos <br />
                    Módulo Cartera <br />
                    Módulo Inventarios <br />
                    3 Usuarios
                  </p>
                </div>
                <div class="has-text-centered">
                  <strong>
                    Para pequeñas y Medianas empresas.
                    <br />
                    <br />
                  </strong>
                </div>

                <a
                  class="button is-block is-primary is-fullwidth is-medium"
                  href="https://api.whatsapp.com/send?phone=573195379810&text=Hola!%20Quiero%20conocer%20mas%20sobre%20yungol%20plus."
                  target="blank"
                >
                  <strong>Quiero Saber más</strong>
                </a>
              </div>
            </div>
            <div class="column">
              <div class="box">
                <div class="is-size-2 has-text-centered">
                  <strong>
                    <h1>yungol Pro</h1>
                  </strong>
                </div>
                <div class="has-text-centered">
                  <H2>Para Grandes Empresas</H2>
                  <br />
                </div>
                <div class="column has-text-primary has-text-centered">
                  <p>
                    Contador Virtual <br />
                    Software contable <br />
                    Facturación Electrónica <br />
                    Modulo de Informes <br />
                    Módulo Facturación <br />
                    Módulo Pagos <br />
                    Módulo Cartera <br />
                    Módulo Inventarios <br />
                    3 Usuarios
                  </p>
                </div>
                <div class="has-text-centered">
                  <p>
                    <strong>
                      <H2>Contáctanos para una asesoria perzonalizada.</H2>
                    </strong>
                    <br />
                  </p>
                </div>

                <a
                  class="button is-block is-primary is-fullwidth is-medium"
                  href="https://api.whatsapp.com/send?phone=573195379810&text=Hola!%20Quiero%20conocer%20mas%20sobre%20yungol%20pro."
                  target="blank"
                >
                  <strong>Quiero Saber más</strong>
                </a>
              </div>
            </div>
            <div class="column">
              <div class="box">
                <div class="is-size-2 has-text-centered">
                  <strong>
                    <h1>software</h1>
                  </strong>
                </div>
                <div class="has-text-centered">
                  <H2>Desde $100.000 mensual</H2>
                  <br />
                </div>
                <div class="column has-text-primary has-text-centered">
                  <p>
                    Software contable <br />
                    Facturación Electrónica <br />
                    Modulo de Informes <br />
                    Módulo Facturación <br />
                    Módulo Pagos <br />
                    Módulo Cartera <br />
                    Módulo Inventarios <br />
                    3 Usuarios
                  </p>
                </div>
                <div class="has-text-centered">
                  <strong
                    >El valor puede varíar segun los requerimientos de cada
                    empresa.</strong
                  >
                  <p>
                    <br />
                  </p>
                </div>

                <a
                  href="https://api.whatsapp.com/send?phone=573195379810&text=Hola!%20Quiero%20conocer%20mas%20sobre%20yungol%20software."
                  target="blank"
                  class="button is-block is-primary is-fullwidth is-medium"
                >
                  <strong>Quiero Saber más</strong>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-fullheight is-link">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-7">
              <img src="@/assets/team yungol.svg" alt="" />
            </div>
            <div class="column is-5">
              <strong>
                <h1 class="title is-1 has-text-white">Nosotros</h1>
              </strong>
              <br />
              <p>
                Yungol mas que una empresa es una familia que cuenta con mas de
                15 años de experiencia en el campo de la contabilidad. Esta
                experiencia nos ha capacitado para dar un servicio de alta
                calidad, ofreciendo a nuestros clientes soluciones en todos los
                entornos de su empresa.
              </p>
              <br />
              <p>
                Trabajamos bajo las últimas tendencias de programación y estamos
                siempre en la búsqueda de las mejores prácticas y metodologías
                para garantizar la calidad en el desarrollo de nuestros
                productos. Nos apasiona brindar soluciones integrales a nuestros
                clientes.
              </p>
              <br />
              <p>
                Yungol es la nueva forma de llevar la contabilidad. Es un
                software que se adapta a la necesidad de grandes, medianas y
                pequeñas empresas. Esta creado con las ultimas tecnologías,
                además de ser un software en la nube, tiene las mismas
                funciones, velocidad y versatilidad de un software de
                escritorio.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-5">
              <img src="@/assets/ceo.jpg" alt="Juan David Jaramillo" />
            </div>
            <div class="column is-5 is is-offset-1">
              <strong>
                <h1 class="title is-1">Nuestra Historia</h1>
              </strong>
              <br />

              <p>
                Todo comenzo en el año 2011, cuando entendimos que tanto las
                empresas como los contadores, carecían de una herramienta que
                les permitiera llevar todos los procesos de una empresa, de
                manera sencilla, organizada y fácil de usar.
                <br /><br />
                Es por eso que nuestro CEO Juan David Jaramillo, asume este gran
                reto y decide aprender a desarrollar, creando un software
                contable que atendiera a todas estas necesidades, puesto que él
                como contador profesional entendía a la perfección lo que se
                requería.
                <br /><br />
                Es en ese momento cuando nace yungol, un software creado con
                toda la pasión y dedicación desde la necesidad de un contador,
                es por eso que para nosotros, es un placer ofrecer nuestros
                servicios a todas las empresas y hacer que nuestro software se
                adapte a todas las necesidades. adapte a todas las necesidades.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <y-Footer></y-Footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import yFooter from "@/components/core/Footer.vue";
import apiServices from "@/services/yungol-services-public";
export default {
  data() {
    return {
      contacto: {
        name: "",
        empresa: "",
        email: "",
        telefono: "",
      },
      phoneNumber: "3195379810",
      mensajeBasico: "Quiero saber sobre el plan básico de yungol",
      mensajeRecomendado: "Quiero saber sobre el plan recomendado de yungol",
    };
  },
  computed: {
    ...mapState(["isAuthenticated", "isMovil"]),
  },
  methods: {
    async sendcontacto(tipo) {
      try {
        if (tipo === "contador") {
          this.contacto.empresa = "Contador";
          this.contacto.telefono = "N/A";
        }
        const result = await apiServices.post(`/contactus`, this.contacto);
        if (result.data) {
          this.$store.dispatch("notify", {
            message:
              "Mensaje enviado. Muy pronto un asesor lo estara contactando.",
          });
          this.contacto = {
            name: "",
            empresa: "",
            email: "",
            telefono: "",
          };
        }
      } catch (err) {
        console.log(err);
      }
    },
    registroGoogle() {
      this.$store.dispatch("notify", {
        message: "Este es un mensaje de prueba",
        type: "is-link",
      });
      this.$ga.event("landing", "prueba"); // con esto se registran eventos en google analytics
    },
    selectclass(clase) {
      let returned;
      if (this.isMovil) {
        returned = `${clase}-movil`;
      } else {
        returned = clase;
      }
      return returned;
    },
  },
  mounted() {
    if (this.$route.hash) {
      console.log("el componente esta montado", this.$route);
      setTimeout(function () {
        document.getElementById("fraelect").scrollIntoView({
          behavior: "smooth",
        });
      }, 500);
    }
  },
  components: {
    yFooter,
  },
};
</script>


<style>
.hero.is-primary.is-bold {
  background-image: linear-gradient(
    141deg,
    #158980 0%,
    #00d1b2 71%,
    #00e7eb 100%
  );
}
.logo {
  width: 90%;
}
.logo-movil {
  widows: 100%;
}
.flecha {
  position: absolute;
  height: 157px;
  margin-top: 74px;
  margin-left: 273px;
  -webkit-transform: rotate(140deg);
  -moz-transform: rotate(140deg);
  -ms-transform: rotate(140deg);
}
.flecha-movil {
  position: absolute;
  height: 157px;
  margin-top: -7px;
  margin-left: 192px;
  -webkit-transform: rotate(140deg);
  -moz-transform: rotate(140deg);
  -ms-transform: rotate(140deg);
}
.largoflecha {
  height: 157px;
}
.largoflecha-movil {
  height: 65px;
}
.sizeflecha {
  width: 250px;
}
.sizeflecha-movil {
  width: 250px;
  max-width: 162px !important;
}
.manosexpertas {
  font-size: 500%;
  line-height: 0.7;
}
.manosexpertas-movil {
  font-size: 378%;
  line-height: 0.7;
}
.boxcontactenos {
  padding: 35px;
  float: left;
  width: 75%;
  -webkit-box-shadow: 20px -20px 0px 1px rgba(0, 0, 0, 0.24);
  -moz-box-shadow: 20px -20px 0px 1px rgba(0, 0, 0, 0.24);
  box-shadow: 20px -20px 0px 1px rgba(0, 0, 0, 0.24);
}
.boxcontactenos-movil {
  padding: 35px;
  float: left;
  width: 100%;
  -webkit-box-shadow: 6px -6px 0px 1px rgba(0, 0, 0, 0.24);
  -moz-box-shadow: 6px -6px 0px 1px rgba(0, 0, 0, 0.24);
  box-shadow: 6px -6px 0px 1px rgba(0, 0, 0, 0.24);
}
.contador {
  position: absolute;
  width: 300px;
  margin-left: -117px;
  margin-top: 8px;
}
.empresario {
  width: 100%;
}
.empresario-movil {
  width: 62%;
  margin-top: 299px;
  margin-left: 94px;
}
.eresempresario {
  font-size: 630%;
  line-height: 1.1;
}
.eresempresario-movil {
  font-size: 400%;
  line-height: 1;
}
.cuadroempresario {
  position: absolute;
  width: 380px;
  height: 500px;
  background-color: rgb(246, 246, 246);
  border-radius: 40px;
}
.cuadroempresario-movil {
  position: absolute;
  margin-top: -5px;
  margin-left: -5px;
  width: 240px;
  height: 303px;
  background-color: rgb(246, 246, 246);
  border-radius: 15px;
}
.cuadroempresario1 {
  position: absolute;
  margin-top: 30px;
  margin-left: 30px;
  width: 380px;
  height: 500px;
  background-color: #209cee;
  border-radius: 40px;
}
.cuadroempresario1-movil {
  position: absolute;
  margin-top: 1px;
  margin-left: 1px;
  width: 240px;
  height: 303px;
  background-color: #209cee;
  border-radius: 15px;
}
.hero.is-blue {
  background-color: #0081c9;
  color: #fff;
}
.diveresempresario {
  position: absolute;
  margin-left: 70px;
  margin-top: 60px;
}
.diveresempresario-movil {
  position: absolute;
  margin-left: 10px;
  margin-top: 10px;
}
.horadeuncambio {
  font-size: 195%;
  line-height: 1.1;
}
.horadeuncambio-movil {
  font-size: 140%;
  line-height: 1.1;
}
</style>



// WEBPACK FOOTER //
// src/components/core/Landing.vue